<template>
  <store-recherche-provider
    key="venteFacture"
    :name="constantes.storeName"
    :copy="ligneCommandeStore"
    :isTemporary="true"
    :copyChanges="changesLigneCommandeStore()">
    <ligne-commande-client
      :tiersId="tiersInformation.id"
      :nameStore="constantes.storeName"
      :type="TYPE_FACTURE"
      :tiersInformation="tiersInformation"/>
  </store-recherche-provider>
</template>

<script>
import ligneCommandeStore, { initialState } from '@/store/modules/ligneCommande';
import ligneCommandeClient from '@/components/clients/clients/ligneCommandeClient';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import {
  ETAT_ENREGISTRE,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  ETAT_PAYE,
  TYPE_FACTURE,
} from '@/configuration/devisConf';

export default {
  name: 'ListeVenteFacture',

  components: {
    storeRechercheProvider,
    ligneCommandeClient,
  },

  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      ligneCommandeStore,
      TYPE_FACTURE,
      constantes: {
        storeName: 'venteFacture',
      },
    };
  },

  methods: {
    changesLigneCommandeStore() {
      const initialStateObject = initialState();

      initialStateObject.criteresRechercheVentes.typeDevisCommande = TYPE_FACTURE;
      initialStateObject.criteresRechercheVentes.etatsDevisCommandeFacture = [
        ETAT_ENREGISTRE,
        ETAT_FACTURE,
        ETAT_FACTURE_PARTIELLEMENT,
        ETAT_PAYE,
      ];

      return {
        state: initialStateObject,
        mutations: {
          RESET_STATE(state) {
            const s = initialState();
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
};
</script>
